import { render, staticRenderFns } from "./BaseButtonPrimary.vue?vue&type=template&id=7233c940&"
import script from "./BaseButtonPrimary.vue?vue&type=script&lang=js&"
export * from "./BaseButtonPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports